<template>
  <div class="commerce-page">
    <commerce-header />
    <main class="commerce-auth-layout">
      <section class="commerce-auth-card">
        <p class="commerce-eyebrow">账号登录</p>
        <h1>登录 AIMason IoT</h1>
        <p class="commerce-auth-card__lead">
          使用统一账号登录物联云与项目云平台。
        </p>

        <form class="commerce-form" novalidate @submit.prevent="handleLogin">
          <div class="commerce-field">
            <label for="login-username">用户名</label>
            <input
              id="login-username"
              v-model.trim="loginForm.username"
              class="commerce-input"
              type="text"
              maxlength="50"
              autocomplete="username"
              placeholder="请输入用户名"
            >
            <p v-if="errors.username" class="commerce-form__error">{{ errors.username }}</p>
          </div>

          <div class="commerce-field">
            <label for="login-password">密码</label>
            <input
              id="login-password"
              v-model="loginForm.password"
              class="commerce-input"
              type="password"
              maxlength="72"
              autocomplete="current-password"
              placeholder="请输入密码"
            >
            <p v-if="errors.password" class="commerce-form__error">{{ errors.password }}</p>
          </div>

          <p v-if="submitError" class="commerce-blockers">{{ submitError }}</p>
          <button class="commerce-button commerce-button--primary" type="submit" :disabled="loading">
            {{ loading ? '正在登录…' : '登录' }}
          </button>
        </form>

        <p class="commerce-auth-switch">
          还没有账号？
          <router-link class="commerce-link" :to="{ path: '/register', query: { redirect: safeRedirect } }">
            注册
          </router-link>
        </p>
      </section>
    </main>
  </div>
</template>

<script>
import CommerceHeader from '@/components/commerce/CommerceHeader.vue'
import { isNavigationFailure, NavigationFailureType } from 'vue-router'
const { loginLandingPath } = require('@/utils/sessionNavigation.cjs')

export default {
  name: 'Login',
  components: { CommerceHeader },
  data() {
    return {
      loading: false,
      submitError: '',
      errors: {},
      loginForm: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    safeRedirect() {
      return loginLandingPath(this.$store.state.user)
    }
  },
  methods: {
    validate() {
      const errors = {}
      if (!this.loginForm.username) errors.username = '请输入用户名'
      if (!this.loginForm.password) errors.password = '请输入密码'
      this.errors = errors
      return Object.keys(errors).length === 0
    },
    async handleLogin() {
      if (!this.validate()) return
      this.loading = true
      this.submitError = ''
      try {
        // 项目可能以地图展示；登录阶段不能提前执行 Three.js/3D 主屏模块。
        await this.$store.dispatch('user/login', this.loginForm)
        await this.$router.push(this.safeRedirect)
      } catch (error) {
        if (isNavigationFailure(error, NavigationFailureType.redirected)) return
        this.submitError = error.message || '登录失败，请检查用户名和密码。'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
